import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";
import * as format from "../../common/FormatFunctions";
export class PartViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getStockOptions = () => {
    var stockOptions = Storage.parseStockOptions();
    this.updateState("stockTypeOptions", stockOptions);
  };

  getOperationalTypeOptions = () => {
    var productTypeArray = Storage.parseOperationalTypeOptions();
    this.updateState("operationalTypeOptions", productTypeArray);
  };

  getParts = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var partResponse = await this.getPartListByCodeTag();
    if (
      Format.isNotNull(partResponse.errorCode) &&
      partResponse.errorCode === 0
    ) {
      if (Format.isNotNull(partResponse.partList)) {
        partResponse.partList.forEach(async element => {
          element.flowRequest = await this.getFlowBeanForEntityAndEntityType(
            this.getComponentList(partResponse.partList, null, true),
            element.id,
            "PART"
          );
        });
        this.updateState("partList", partResponse.partList);
        this.logger.info(partResponse.partList);
      } else {
        this.showEmpty("Part");
      }
    } else {
      this.showError("Part", CrudlStatus.LIST);
    }
  };
  getPartsReturned = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var partResponse = await this.getPartListByCodeTag();
    if (
      Format.isNotNull(partResponse.errorCode) &&
      partResponse.errorCode === 0
    ) {
      if (Format.isNotNull(partResponse.partList)) {
        partResponse.partList.forEach(async element => {
          element.flowRequest = await this.getFlowBeanForEntityAndEntityType(
            this.getComponentList(partResponse.partList, null, true),
            element.id,
            "PART"
          );
        });
        this.logger.info(partResponse.partList);
        return partResponse.partList;
      } else {
        this.showEmpty("Part");
      }
    } else {
      this.showError("Part", CrudlStatus.LIST);
    }
  };
  getComponentList = (partList, subAssemblyList, returnValue) => {
    var componentList = [];

    if (format.isNotNull(partList)) {
      partList.forEach(element => {
        var localPart = format.deepCopy(element);
        localPart.componentType = "PART";
        componentList.push(localPart);
      });
    }
    if (format.isNotNull(subAssemblyList)) {
      subAssemblyList.forEach(element => {
        var localPart = format.deepCopy(element);
        localPart.componentType = "SUB-ASSEMBLY";
        componentList.push(localPart);
      });
    }
    console.log(componentList);
    if (returnValue === true) {
      return componentList;
    } else {
      this.updateState("componentList", componentList);
    }
  };
  getPartAndFlow = async (partList, subList, id) => {
    let partRequest = new CloudService.PartRequest();
    partRequest.codeTag = this.codeTag;
    partRequest.userId = this.userId;
    partRequest.id = id;

    var partResponse = await ApiService.partGetByIdAndFlow(partRequest);
    var loadedFlowBean = {};
    if (partResponse.errorCode === 0) {
      // partResponse.selectedComponents = this.getComponentListFromPartResponse(
      //   partResponse,
      //   partList,
      //   subList
      // );
      if (Format.isNotNull(partResponse.flowResponseList)) {
        loadedFlowBean = this.convertFlowResponseToFlowBean(
          format.deepCopy(partResponse.flowResponseList[0])
        );
        loadedFlowBean = this.renderPartsAndProductsFromJson(
          loadedFlowBean,
          this.getComponentList(partList, null, true)
        );

        partResponse.flowRequest = loadedFlowBean;
        delete partResponse.flowResponseList;
      }
    }
    return partResponse;
  };
  getAttributeSets = async () => {
    //NON CRITICAL - NO ERROR MESSAGE
    var attributeSetResponse = await this.getAttributeSetListByCodeTag();
    if (
      Format.isNotNull(attributeSetResponse.errorCode) &&
      attributeSetResponse.errorCode === 0
    ) {
      if (Format.isNotNull(attributeSetResponse.attributeSetList)) {
        this.logger.info(attributeSetResponse.attributeSetList);
        this.updateState(
          "attributeSetList",
          attributeSetResponse.attributeSetList
        );

        var attributeArray = UIMap.getListOptions(
          attributeSetResponse.attributeSetList,
          "name"
        );
        var attributeMap = UIMap.getDropdownOptions(
          attributeSetResponse.attributeSetList
        );
        this.updateState("attributeSetMap", attributeMap);
        this.updateState("attributeSetOptions", attributeArray);
      } else {
        //this.showEmpty("AttributeSet");
      }
    } else {
      //this.showError("AttributeSet", CrudlStatus.LIST);
    }
  };

  getSuppliers = async () => {
    //NON CRITICAL - NO ERROR MESSAGE
    var supplierResponse = await this.getAttributeSetListByCodeTag();
    if (
      Format.isNotNull(supplierResponse.errorCode) &&
      supplierResponse.errorCode === 0
    ) {
      if (Format.isNotNull(supplierResponse.buisnesses)) {
        this.logger.info(supplierResponse.buisnesses);
        this.updateState("supplierList", supplierResponse.buisnesses);

        var array = UIMap.getListOptions(supplierResponse.buisnesses, "name");
        var map = UIMap.getDropdownOptionsExtension(
          supplierResponse.buisnesses,
          "name",
          "name"
        );
        this.updateState("supplierMap", map);
        this.updateState("supplierOptions", array);
      } else {
        //this.showEmpty("Supplier");
      }
    } else {
      //this.showError("Supplier", CrudlStatus.LIST);
    }
  };
  getStations = async () => {
    var stationResponse = await this.getStationListByCodeTag();
    if (
      Format.isNotNull(stationResponse.errorCode) &&
      stationResponse.errorCode === 0
    ) {
      if (Format.isNotNull(stationResponse.stationList)) {
        this.updateState("stationList", stationResponse.stationList);
        var attributeArray = UIMap.getListOptions(
          stationResponse.stationList,
          "name"
        );
        var attributeMap = UIMap.getDropdownOptions(
          stationResponse.stationList
        );
        this.updateState("stationMap", attributeMap);
        this.updateState("stationOptions", attributeArray);
        this.logger.info(stationResponse.stationList);
      } else {
        //this.showEmpty("Station")
      }
    } else {
      this.showError("Station", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (parts, apiResponse, type, externalStateValues) => {
    var updatedPartList = [];
    if (type === CrudlStatus.CREATE) {
      updatedPartList = this.reloadAfterCreate(
        parts,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedPartList = this.reloadAfterUpdate(
        parts,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedPartList = this.reloadAfterDelete(
        parts,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("partList", updatedPartList);
  };

  reloadAfterCreate = (partList, apiResponse, externalStateValues) => {
    if (partList === undefined || partList === null) {
      partList = [];
    }
    var partBean = externalStateValues.partBean;
    partBean.id = apiResponse.id;
    partBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    partList.push(partBean);

    return partList;
  };

  reloadAfterUpdate = (partList, apiResponse, externalStateValues) => {
    var i = 0;
    partList.forEach(e => {
      if (apiResponse.id === e.id) {
        partList[i] = externalStateValues.partBean;
        partList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return partList;
  };

  reloadAfterDelete = (partList, apiResponse, externalStateValues) => {
    var i = 0;
    partList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        partList.splice(i, 1);
      }
      i++;
    });

    return partList;
  };
  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let partRequest = stateVariables.partBean;

    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createPart(partRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updatePart(partRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deletePart(partRequest);
    }
  };

  createPart = async (partRequest, stateVariables) => {
    partRequest.codeTag = this.codeTag;
    partRequest.userId = this.userId;

    if (format.isNotNull(partRequest.flowRequest)) {
      if (format.isNotNull(partRequest.flowRequest.flowItemList)) {
        var flowRequestList = [];
        var flowRequest = this.renderJsonFromPartsAndProducts(
          format.deepCopy(partRequest.flowRequest),
          partRequest.selectedComponents,
          partRequest.id
        );
        flowRequestList.push(flowRequest);
        partRequest.flowRequestList = flowRequestList;
      }
    } else {
      // NO NEED TO DO ANYTHING REQUEST WONT PASS UP FLOW JUST
    }
    let partResponse = await ApiService.partCreate(partRequest);
    if (partResponse.errorCode === 0) {
      this.showSuccess("Part", CrudlStatus.CREATE);
    } else {
      this.showError("Part", CrudlStatus.CREATE);
    }

    return partResponse;
  };

  deletePart = async partRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = partRequest.id;
    request.lastUpdatedDateTime = partRequest.lastUpdatedDateTime;

    let partResponse = await ApiService.partDelete(request);
    if (partResponse.errorCode === 0) {
      this.showSuccess("Part", CrudlStatus.DELETE);
    } else {
      this.showError("Part", CrudlStatus.DELETE);
    }

    return partResponse;
  };

  updatePart = async (partRequest, stateVariables) => {
    partRequest.codeTag = this.codeTag;
    partRequest.userId = this.userId;
    console.log(partRequest);
    if (format.isNotNull(partRequest.flowRequest)) {
      if (format.isNotNull(partRequest.flowRequest.flowItemList)) {
        var flowRequest = this.renderJsonFromPartsAndProducts(
          format.deepCopy(partRequest.flowRequest),
          partRequest.selectedComponents,
          partRequest.id
        );

        await this.updateOriginalFlowBean(
          flowRequest.id,
          flowRequest.lastUpdatedDateTime
        );
      }

      flowRequest.entityId = partRequest.id;
      flowRequest.entityName = "PART";
      var createErrorCode = await this.saveFlow(flowRequest);
    } else {
      // NO NEED TO DO ANYTHING REQUEST WONT PASS UP FLOW JUST
    }
    // delete productRequest.selectedComponents;
    let partResponse = await ApiService.partUpdate(partRequest);
    if (partResponse.errorCode === 0) {
      this.showSuccess("Part", CrudlStatus.UPDATE);
    } else {
      this.showError("Part", CrudlStatus.UPDATE);
    }

    return partResponse;
  };
  saveFlow = async flowBean => {
    var flowBeanParsed = Format.deepCopy(flowBean);

    this.logger.info(flowBeanParsed);
    let flowRequest = CloudService.FlowRequest.constructFromObject(
      flowBeanParsed
    );

    flowRequest.codeTag = this.codeTag;
    flowRequest.userId = this.userId;

    let flowResponse = await ApiService.flowCreate(flowRequest);
    if (Format.isNotNull(flowResponse)) {
      return flowResponse.errorCode;
    } else {
      return 9999;
    }
  };
  updateOriginalFlowBean = async (id, lastUpdatedDateTime) => {
    var flowRequest = new CloudService.FlowRequest();

    flowRequest.codeTag = this.codeTag;
    flowRequest.userId = this.userId;
    flowRequest.id = id;
    flowRequest.lastUpdatedDateTime = lastUpdatedDateTime;
    flowRequest.active = false;

    let flowResponse = await ApiService.flowUpdate(flowRequest);
    this.logger.info(flowResponse);
    if (Format.isNotNull(flowResponse)) {
      return flowResponse.errorCode;
    } else {
      return 9999;
    }
  };
  getFlowBeanForEntityAndEntityType = async (
    componentList,
    entityId,
    entityType
  ) => {
    if (entityType === "PART") {
      let partRequest = new CloudService.PartRequest();
      partRequest.codeTag = this.codeTag;
      partRequest.userId = this.userId;
      partRequest.id = entityId;

      var partResponse = await ApiService.partGetByIdAndFlow(partRequest);
      var loadedFlowBean = {};
      if (partResponse.errorCode === 0) {
        if (Format.isNotNull(partResponse.flowResponseList)) {
          loadedFlowBean = this.convertFlowResponseToFlowBean(
            partResponse.flowResponseList[0]
          );
          loadedFlowBean = this.renderPartsAndProductsFromJson(
            loadedFlowBean,
            componentList
          );
          this.updateState("crudlStatus", CrudlStatus.UPDATE);
          this.logger.info(loadedFlowBean);
          return loadedFlowBean;
        } else {
          loadedFlowBean = new CloudService.FlowBean();
          loadedFlowBean.entityId = entityId;
          loadedFlowBean.entityType = entityType;
          this.updateState("crudlStatus", CrudlStatus.CREATE);
          this.logger.info(loadedFlowBean);
          return loadedFlowBean;
        }
      } else {
        loadedFlowBean = new CloudService.FlowBean();
        loadedFlowBean.entityId = entityId;
        loadedFlowBean.entityType = entityType;
        this.updateState("crudlStatus", CrudlStatus.CREATE);
        this.logger.info(loadedFlowBean);
        return loadedFlowBean;
      }
    }
  };

  convertFlowResponseToFlowBean = flowResponse => {
    // flowItemResponseList => flowItemList

    var localFlowResponse = Format.deepCopy(flowResponse);

    var flowBean = CloudService.FlowBean.constructFromObject(localFlowResponse);

    flowBean.flowItemList = localFlowResponse.flowItemResponseList;

    return flowBean;
  };

  convertFlowBeanToFlowRequest = flowBean => {
    return flowBean;
  };

  renderPartsAndProductsFromJson = (flowBean, componentList) => {
    var partList = [];
    var productList = [];

    if (format.isNotNull(componentList)) {
      componentList.forEach(element => {
        if (element.componentType === "PART") {
          partList.push(element);
        } else {
          productList.push(element);
        }
      });
    }
    var localFlowBean = Format.deepCopy(flowBean);
    if (Format.isNotNull(localFlowBean.flowItemList)) {
      localFlowBean.flowItemList.forEach(element => {
        var parsedInputPartList = [];
        var parsedInputProductList = [];
        var parsedOutputPartList = [];
        var parsedOutputProductList = [];

        if (Format.isNotNull(element.inputJson)) {
          var inputPartList = JSON.parse(element.inputJson).parts;
          if (Format.isNotNull(inputPartList)) {
            inputPartList.forEach(inputPart => {
              if (Format.isNotNull(partList)) {
                componentList.forEach(part => {
                  var parsedInputPart = inputPart;
                  if (parsedInputPart.id === part.id) {
                    var quantity = 1;
                    if (parsedInputPart.quantity) {
                      quantity = parsedInputPart.quantity;
                    }
                    parsedInputPartList.push({
                      name: part.name,
                      quantity: quantity
                    });
                    this.logger.info(
                      "Part " + inputPart + " matches with id " + part.id
                    );
                  }
                });
              }
            });
          }

          var inputProductList = JSON.parse(element.inputJson).products;
          if (Format.isNotNull(inputProductList)) {
            inputProductList.forEach(inputProduct => {
              if (Format.isNotNull(productList)) {
                productList.forEach(product => {
                  var parsedInputProduct = inputProduct;
                  if (parsedInputProduct.id === product.id) {
                    var quantity = 1;
                    if (parsedInputProduct.quantity) {
                      quantity = parsedInputProduct.quantity;
                    }
                    parsedInputProductList.push({
                      name: product.name,
                      quantity: quantity
                    });
                    this.logger.info(
                      "Product " +
                        inputProduct +
                        " matches with id " +
                        product.id
                    );
                  }
                });
              }
            });
          }
        }

        if (Format.isNotNull(element.outputJson)) {
          var outputPartList = JSON.parse(element.outputJson).parts;
          if (Format.isNotNull(outputPartList)) {
            outputPartList.forEach(outputPart => {
              if (Format.isNotNull(partList)) {
                partList.forEach(part => {
                  var parsedOutputPart = outputPart;
                  if (parsedOutputPart.id === part.id) {
                    var quantity = 1;
                    if (parsedOutputPart.quantity) {
                      quantity = parsedOutputPart.quantity;
                    }
                    parsedOutputPartList.push({
                      name: part.name,
                      quantity: quantity
                    });
                    this.logger.info(
                      "Part " + outputPart + " matches with id " + part.id
                    );
                  }
                });
              }
            });
          }

          var outputProductList = JSON.parse(element.outputJson).products;
          if (Format.isNotNull(outputProductList)) {
            outputProductList.forEach(outputProduct => {
              if (Format.isNotNull(productList)) {
                productList.forEach(product => {
                  var parsedOutputProduct = outputProduct;
                  if (parsedOutputProduct.id === product.id) {
                    var quantity = 1;
                    if (parsedOutputProduct.quantity) {
                      quantity = parsedOutputProduct.quantity;
                    }
                    parsedOutputProductList.push({
                      name: product.name,
                      quantity: quantity,
                      id: product.id
                    });

                    this.logger.info(
                      "Product " +
                        outputProduct +
                        " matches with id " +
                        product.id
                    );
                  }
                });
              }
            });
          }
        }

        // delete element.inputJson;
        // delete element.outputJson;

        var localInputComponentList = [];
        if (Format.isNotNull(parsedInputPartList)) {
          parsedInputPartList.forEach(element => {
            var localElement = Format.deepCopy(element);
            localElement.componentType = "PART";
            localInputComponentList.push(localElement);
          });
        }
        if (Format.isNotNull(parsedInputProductList)) {
          parsedInputProductList.forEach(element => {
            var localElement = Format.deepCopy(element);
            localElement.componentType = "SUB-ASSEMBLY";
            localInputComponentList.push(localElement);
          });
        }

        var localOutputComponentList = [];
        if (Format.isNotNull(parsedOutputPartList)) {
          parsedOutputPartList.forEach(element => {
            var localElement = Format.deepCopy(element);
            localElement.componentType = "PART";
            localOutputComponentList.push(localElement);
          });
        }
        if (Format.isNotNull(parsedOutputProductList)) {
          parsedOutputProductList.forEach(element => {
            var localElement = Format.deepCopy(element);
            localElement.componentType = "SUB-ASSEMBLY";
            localOutputComponentList.push(localElement);
          });
        }

        element.inputComponentList = localInputComponentList;
        element.outputComponentList = localOutputComponentList;
        element.outputPartList = parsedOutputPartList;
        element.outputProductList = parsedOutputProductList;
      });
    }
    return localFlowBean;
  };

  renderJsonFromPartsAndProducts = (
    currentFlowBean,
    componentList,
    productId
  ) => {
    console.log(currentFlowBean);
    console.log(componentList);
    console.log(productId);

    var localFlowBean = Format.deepCopy(currentFlowBean);
    var i = 1;
    var lengthToCheck = localFlowBean.flowItemList.length;
    localFlowBean.flowItemList.forEach(element => {
      var parsedInputPartList = [];
      var parsedInputProductList = [];
      var parsedOutputPartList = [];
      var parsedOutputProductList = [];

      if (Format.isNotNull(element.inputComponentList)) {
        element.inputComponentList.forEach(inputPart => {
          componentList.forEach(part => {
            if (inputPart.name === part.name) {
              var quantity = 1;
              if (inputPart.quantity) {
                quantity = inputPart.quantity;
              }
              if (part.componentType === "PART") {
                parsedInputPartList.push({ id: part.id, quantity: quantity });
                this.logger.info(
                  "Part " + inputPart + " matches with id " + part.id
                );
              }
              if (part.componentType === "SUB-ASSEMBLY") {
                parsedInputProductList.push({
                  id: part.id,
                  quantity: quantity
                });
                this.logger.info(
                  "Product " + inputPart + " matches with id " + part.id
                );
              }
            }
          });
        });
      }

      //OUTPUT CODE COMMENTED OUT FOR NOW
      // if (Format.isNotNull(element.outputPartList)) {
      //   element.outputPartList.forEach(outputPart => {
      //     partList.forEach(part => {
      //       if (outputPart.name === part.name) {
      //         var quantity = 1;
      //         if (outputPart.quantity) {
      //           quantity = outputPart.quantity;
      //         }
      //         parsedOutputPartList.push({ id: part.id, quantity: quantity });
      //         this.logger.info(
      //           "Part " + outputPart + " matches with id " + part.id
      //         );
      //       }
      //     });
      //   });
      // }
      // if (Format.isNotNull(element.outputProductList)) {
      //   element.outputProductList.forEach(outputProduct => {
      //     productList.forEach(product => {
      //       if (outputProduct.name === product.name) {
      //         var quantity = 1;
      //         if (outputProduct.quantity) {
      //           quantity = outputProduct.quantity;
      //         }
      //         parsedOutputProductList.push({
      //           id: product.id,
      //           quantity: quantity
      //         });
      //         this.logger.info(
      //           "Product " + outputProduct + " matches with id " + product.id
      //         );
      //       }
      //     });
      //   });
      // }

      if (i === lengthToCheck) {
        this.logger.info("Found last item, adding " + productId);
        parsedOutputPartList.push({ id: productId, quantity: 1 });
      }

      var inputJson = {
        parts: parsedInputPartList,
        products: parsedInputProductList
      };
      var inputJsonString = JSON.stringify(inputJson);

      var outputJson = {
        parts: parsedOutputPartList,
        products: parsedOutputProductList
      };
      var outputJsonString = JSON.stringify(outputJson);

      element.inputJson = inputJsonString;
      element.outputJson = outputJsonString;
      delete element.inputPartList;
      delete element.inputProductList;
      delete element.outputPartList;
      delete element.outputProductList;
      delete element.inputComponentList;
      i++;
    });

    return localFlowBean;
  };
}



// WEBPACK FOOTER //
// ./src/components/Part/PartViewModel.js